import type { ISGWTConnectIdTokenClaims, SGWTConnectCore } from '@sgwt/connect-core';
import { setupSGWTConnect } from '@sgwt/connect-core';
import { first } from 'lodash-es';
import { getSgmeConfiguration } from 'state/configureStore';

const mockedSgConnect = {
  getAuthorizationHeader: () => 'mocked-bearer-token',
  isAuthorized: () => true,
  on: () => mockedSgConnect,
  requestAuthorization: () => {
    return mockedSgConnect;
  },
  getIdTokenClaims: () => {
    return { sub: 'fake.user@sgcib.com' } as ISGWTConnectIdTokenClaims;
  },
} as Partial<SGWTConnectCore> as SGWTConnectCore;

function bootstrapSgConnect(sgmeConfiguration: SgmeConfiguration): SGWTConnectCore {
  if (!sgmeConfiguration) {
    throw new Error('sgmeConfiguration is not provided on Window');
  }
  if (sgmeConfiguration.disableSgConnect === true) {
    return mockedSgConnect; // for integration test only
  }

  if (sgmeConfiguration.mockSgConnect) {
    const fakeClientId = getFakeClientId();

    if (fakeClientId) {
      document.cookie = `Fake_ClientId=${fakeClientId};`;
      sgmeConfiguration.sgConnect.client_id = fakeClientId;
    }
  }

  return setupSGWTConnect(sgmeConfiguration.sgConnect);
}

export const sgwtConnect = bootstrapSgConnect(getSgmeConfiguration());

function getFakeEmail(): string | null {
  const params = new URLSearchParams(self.location.search);
  const fakeEmail = params.get('fakeSSO');
  if (fakeEmail) {
    return fakeEmail.split('@')[0];
  }
  return null;
}

export function getImpersonatedUser(): { name: string; mail: string } | null {
  if (isInconsistentFakeSso()) {
    const clientId = getFakeClientId();
    const mail = getFakeEmail();
    if (clientId) {
      return { name: clientId, mail: mail ?? clientId };
    }
  }
  return null;
}

export function getFakeClientId(): string | null {
  if (!getSgmeConfiguration().mockSgConnect) {
    return null;
  }
  const fakeEmail = getFakeEmail();
  if (fakeEmail) {
    return fakeEmail;
  }
  const cookieFakeClientId = first(
    document.cookie
      .split(';')
      .filter(r => r.trim().startsWith('Fake_ClientId'))
      .map(r => r.trim().split('=')[1]),
  );
  if (cookieFakeClientId) {
    return cookieFakeClientId;
  }
  return null;
}

export function isInconsistentFakeSso(): boolean {
  if (!getSgmeConfiguration().mockSgConnect) {
    return false;
  }

  return getFakeClientId() !== null && !sgwtConnect.getIdTokenClaims()?.sub?.startsWith(getFakeClientId() + '@');
}
